import { CsrfFetchInterceptor } from "../Security/CsrfFetchInterceptor.js";

CsrfFetchInterceptor.install();

const FIVE_MINUTES = 300000; // 5 minutes

export class BodyWrapper extends HTMLElement
{
    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.init();
    }

    initFiveMinuteTimer()
    {
        // setup interval to check every 5 minutes on the 5-minute mark (e.g. 10:00, 10:05, 10:10, etc.)
        // calculate the delay until the next 5-minute mark
        const now = new Date();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();
        const milliseconds = now.getMilliseconds();
        const msIntoCurrentInterval = ((minutes % 5) * 60 + seconds) * 1000 + milliseconds;
        const delayUntilNextInterval = msIntoCurrentInterval === 0
            ? 0
            : FIVE_MINUTES - msIntoCurrentInterval;
      
        setTimeout(() => {
            // broadcast 5 minute mark event for other components to listen to if needed
            const event = new CustomEvent('five-minute-mark', {
                detail: {
                    timestamp: new Date()
                }
            });
            document.body.dispatchEvent(event);
            setInterval(() => {
                const event = new CustomEvent('five-minute-mark', {
                    detail: {
                        timestamp: new Date()
                    }
                });
                document.body.dispatchEvent(event);
            }, FIVE_MINUTES);
        }, delayUntilNextInterval);
    }

    init()
    {
        this.initEventHandlers(); 
        this.initFiveMinuteTimer();
    }

    initEventHandlers()
    {
    }

}

customElements.define("body-wrapper", BodyWrapper);